import { render, staticRenderFns } from "./FakturaEdit.vue?vue&type=template&id=466d96f8&scoped=true"
import script from "./FakturaEdit.vue?vue&type=script&lang=js"
export * from "./FakturaEdit.vue?vue&type=script&lang=js"
import style0 from "./FakturaEdit.vue?vue&type=style&index=0&id=466d96f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d96f8",
  null
  
)

export default component.exports